export default function PaymentCodesService(
    tripAPI
) {
    'ngInject';

    return {
        validatePaymentCode,
        validatePaymentCodeWithParent,
        getChildPaymentCodes,
    };

    function validatePaymentCode(paymentCode) {
        return tripAPI.validatePaymentCode(paymentCode);
    }

    function validatePaymentCodeWithParent(paymentCode) {
        return tripAPI.validatePaymentCodeWithParent(paymentCode);
    }

    function getChildPaymentCodes(paymentCode) {
        return tripAPI.getChildPaymentCodes(paymentCode);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-list/hierarchical-payment-codes/hierarchical-payment-codes-service.js